import React, {Component} from 'react';
import {Grid, Row, Col, Tabs, Tab} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import RozliczenieKursySzczegoloweContainer from "./Szczegolowe/RozliczenieKursySzczegoloweContainer";
import RozliczenieKursyKierowcyContainer from "./Kierowcy/RozliczenieKursyKierowcyContainer";
import RozliczenieKursyPojazdyContainer from "./Pojazdy/RozliczenieKursyPojazdyContainer";
import RozliczenieKursySearchform from "./components/RozliczenieKursySearchform";
import moment from 'moment'
import DateAndTimeFormat from "../../../utilities/DateAndTimeFormat";

export default class RozliczenieKursowContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1,
            daty:[DateAndTimeFormat.formatYYYYMMDD(moment()),DateAndTimeFormat.formatYYYYMMDD(moment())]
        };
        this.changeActiveTab = this.changeActiveTab.bind(this)
    }

    renderContent() {
        if (this.state.activeTab === 1) {
            return <RozliczenieKursySzczegoloweContainer daty={this.state.daty}/>
        }
        else if (this.state.activeTab === 2) {
            return <RozliczenieKursyKierowcyContainer daty={this.state.daty}/>
        }
        else {
            return <RozliczenieKursyPojazdyContainer daty={this.state.daty}/>
        }
    }

    changeActiveTab(eventKey) {
        this.setState({activeTab: eventKey})
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'RaportyContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb
                                    links={[{addressUrl: '/raporty', text: 'Raporty'}, {
                                        addressUrl: '/raporty/rozliczenie-kursow',
                                        text: 'Rozliczenie kursów'
                                    }]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <RozliczenieKursySearchform handleClickSzukaj={
                                (dod, ddo) => {
                                    this.setState({daty:[dod,ddo]})
                                }}/>
                        </Col>
                        <Col sm={12} style={{marginTop: '15px'}}>
                            <Tabs defaultActiveKey={1} id="rozliczenie-kursow-tab" onSelect={this.changeActiveTab}>
                                <Tab eventKey={1} title="Rozliczenie kursów szczegółowe">
                                </Tab>
                                <Tab eventKey={2} title="Rozliczenie kursów kierowców">
                                </Tab>
                                <Tab eventKey={3} title="Roliczenie kursów pojazdów">
                                </Tab>
                            </Tabs>
                        </Col>
                        <Col sm={12}>
                            <div style={{marginTop: '15px', marginBottom:'5px'}}>
                                {this.renderContent()}
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/RozliczenieKursow/RozliczenieKursowContainer.js